import carousel_one from "../assets/gallery/gallery-1.jpg";
import carousel_two from "../assets/gallery/gallery-2.jpg";
import carousel_three from "../assets/gallery/gallery-3.jpg";
import carousel_four from "../assets/gallery/gallery-4.jpg";
import carousel_five from "../assets/gallery/gallery-5.jpg";
import carousel_six from "../assets/gallery/gallery-6.jpg";

export const carousel = [
    { id: 1, imageUrl: carousel_one, title: "Manicure", description: "Elegant Nail Finishing" },
    { id: 2, imageUrl: carousel_two, title: "Pedicure", description: "Revitalizing Foot Care" },
    { id: 3, imageUrl: carousel_three, title: "Massage", description: "Deep Tissue Relaxation" },
    { id: 4, imageUrl: carousel_four, title: "Hot steaming", description: "Pore-Cleansing Steam Therapy" },
    { id: 5, imageUrl: carousel_five, title: "Skin care", description: "Radiant Skin Treatments" },
    { id: 6, imageUrl: carousel_six, title: "Hair care", description: "Silky Smooth Hair Transformation" }
]